import { createSelector } from "@reduxjs/toolkit";
import viewTitle from "views/logic/views/ViewTitle";
import useViewsSelector from "views/stores/useViewsSelector";
import { selectView, selectViewType } from "views/logic/slices/viewSelectors";
const selectViewTitle = createSelector(
  selectView,
  selectViewType,
  (view, viewType) => viewTitle(view == null ? void 0 : view.title, viewType)
);
const useViewTitle = () => useViewsSelector(selectViewTitle);
export default useViewTitle;
